import { authRequest } from "src/engine/modules/authRequest"

// Спека https://next.stoplight.io/infotech-group/planner/version%2F1.0/main.oas2.yml?view=/calendars

export const getCalendar = ({
  startDateTime,
  endDateTime,
  zone,
  groupByDay,
  resourceQuery,
  eventQuery,
  limit,
  offset,
  orderBy,
} = {}) =>
  authRequest({
    url: `/calendar`,
    params: {
      startDateTime,
      endDateTime,
      zone,
      groupByDay,
      resourceQuery,
      eventQuery,
      limit,
      offset,
      orderBy,
    },
  })

export const getPlanCalendar = ({
  startDateTime,
  endDateTime,
  zone,
  groupByDay,
  resourceQuery,
  eventQuery,
  limit,
  offset,
  planId,
  orderBy,
} = {}) =>
  authRequest({
    url: `/plans/${planId}/calendar`,
    params: {
      startDateTime,
      endDateTime,
      zone,
      groupByDay,
      resourceQuery,
      eventQuery,
      limit,
      offset,
      orderBy,
    },
  })
